import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";
import { isJson } from "../../../../../core/data/Helpers";

const INIT_STATE = {
  loadingTemperatures: false,
  temperatures: [],
  totalTemperatures: 0,
  error: null
};

const route = "modules/manage/views/main/components/temperatureTab/redux/slice.";

export const manageSearchTemperatures = createAsyncThunk(
  "manage/temperatureTab/manageSearchTemperatures",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchTemperatures.query,
        {
          conditions,
          sort,
          limit,
          offset
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      if (!response?.data) return { items: [], total: 0 };
      return response.data
    } catch (exc) {
      ExceptionManager(exc, route, "manageSearchTemperatures");
      return rejectWithValue(exc);
    }
  }
);

manageSearchTemperatures.query = `
              query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                data: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        hid
                        label
                        esn
                        imei
                        linkedUnitId
                        linkedUnit {
                            id
                            label
                        }
                        systemAlertAssignment{
                            id
                            }
                        temperatureAlerts {
                            id
                            name
                            configJSON
                            subscribers {
                                id
                                contactId
                            }
                        }
                    }
                    total
                }
            }
          `

//Slice
const manageTemperatureTabRedux = createSlice({
  name: "manage/temperatureTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchTemperatures
    builder.addCase(manageSearchTemperatures.pending, (state) => {
      state.loadingTemperatures = true;
    });
    builder.addCase(manageSearchTemperatures.fulfilled, (state, action) => {
      state.loadingTemperatures = false;
      state.temperatures = action.payload.items;
      state.totalTemperatures = action.payload.total;
    });
    builder.addCase(manageSearchTemperatures.rejected, (state, action) => {
      state.loadingTemperatures = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageTemperatureTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
